import { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { Button, ButtonGroup } from 'reactstrap';

import { Divider } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { DonorType as Type, SearchType } from 'types/api/audience';
import { s } from 'utilities';

const formName = `${SearchType.Attributes}.includeNonDonor`;

const DonorType = () => {
  const { getValues, setValue } = useFormContext();

  const getValue = useCallback(() => {
    const formValues = getValues(formName);

    if (isDefined(formValues)) {
      const { value } = formValues;

      return value;
    }

    return null;
  }, [getValues]);

  return (
    <>
      <Divider>{s(['Site.Donor', 'Site.Type'])}</Divider>
      <ButtonGroup className="mt-3 mb-3">
        <Button
          active={getValue() == Type.Donors}
          color="primary"
          onClick={() => {
            setValue(formName, {
              formName: 'includeNonDonor',
              value: Type.Donors,
            });
          }}
          outline
          type="button">
          {s(['Site.Donor', 'Site.Only'])}
        </Button>
        <Button
          active={getValue() == Type.Both}
          color="primary"
          onClick={() =>
            setValue(formName, {
              formName: 'includeNonDonor',
              value: Type.Both,
            })
          }
          outline
          type="button">
          {s('Site.Both')}
        </Button>
        <Button
          active={getValue() == Type.NonDonors}
          color="primary"
          onClick={() =>
            setValue(formName, {
              formName: 'includeNonDonor',
              value: Type.NonDonors,
            })
          }
          outline
          type="button">
          {s(['Site.NonDonor', 'Site.Only'])}
        </Button>
      </ButtonGroup>
    </>
  );
};

export default DonorType;
